var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"data-title":"我的分销海报"}},[_c('img',{staticStyle:{"width":"90%","margin-left":"5%","margin-top":"5%"},attrs:{"src":'data:image/png;base64,'+_vm.posterbase64}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","color":"black","font-size":"16px"}},[_vm._v("长按海报保存到手机或者发送")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f506568","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/mydisposter.vue
// module id = UmGn
// module chunks = 5